var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"arrow-icon",class:_vm.bem('arrow-icon', { direction: _vm.direction })},[_c('SvgIcon',{attrs:{"icon":_vm.type ? ("arrow-" + _vm.type) : 'arrow',"size":_vm.size,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }